package navigation.settings.general

import com.essntl.core.settings.domain.model.configuration.ConfigurationLogoModel
import com.essntl.core.utils.viewmodel.State

data class GeneralState(
    val getLogo: State<ConfigurationLogoModel?> = State(),
    val deleting: Boolean = false,
)
